<template lang="html">
  <cw-basic-cell @click="$emit('click')">
    <div class="cell-contents" slot="left-fill-area">
      <div class="flex flex-align-center">
        <div class="is-growable">
          <div class="columns my-0">
            <div class="column py-0 is-size-5 has-text-weight-medium rubik-400">
              {{ `INVOICE #${invoice.id}` }}
              <span
                v-if="displayPaymentInfo && invoice.balance === 0"
                class="icon has-text-green is-not-growable"
              >
                <i class="las la-2x la-check-circle"></i>
              </span>
            </div>
            <p
              class="py-0 px-3 is-size-5 rubik-400 has-text-right-tablet has-text-left-mobile is-2"
            >
              {{ `$${invoice.amount || ' '}` }}
              <span v-if="displayPaymentInfo && invoice.balance !== 0">
                |
                <span class="has-text-primary">{{
                  `$${invoice.balance}`
                }}</span>
              </span>
            </p>
          </div>

          <div class="columns my-0">
            <p class="column py-0 is-size-5 has-text-grey">
              <span class="is-pad-right-1">{{ invoice.projectName }}</span>
              <span
                v-if="invoice.subProjectName !== 'n/a'"
                class="has-border-left is-padded-small border-color-gray  is-vertical-paddingless "
              >
                {{ `Lot ${invoice.subProjectName}` }}</span
              >
            </p>
            <p
              class="py-0 px-3 is-size-6 has-text-grey has-text-right-tablet is-2"
            >
              {{ invoice.invoiceDate }}
            </p>
          </div>
          <p class="is-size-6 has-text-grey-light">
            {{ invoice.description || '  ' }}
          </p>
        </div>
        <a
          class="icon has-text-primary is-medium is-not-growable"
          :href="invoice.invoiceArchiveURL"
        >
          <i class="las la-2x la-download"></i>
        </a>
      </div>
    </div>
  </cw-basic-cell>
</template>

<script>
export default {
  name: 'cw-invoice-cell',
  props: {
    invoice: {
      type: Object,
      required: true,
    },
    displayPaymentInfo: {
      type: Boolean,
      default: false,
    },
    showDisclosureIndicator: {
      type: Boolean,
      required: false,
      default: true,
    },
    showSelectedIndicator: {
      type: Boolean,
      required: false,
      default: false,
    },
    iconProps: {
      type: Object,
      required: false,
      default: () => {
        return {
          name: 'pin',
          scale: 2,
          colorClass: 'has-text-grey-light',
        };
      },
    },
  },
  methods: {},
};
</script>

<style lang="stylus">
.column.py-0 {
  padding-top: 0;
  padding-bottom: 0;
}
.columns.my-0 {
  margin-top: 0;
  margin-bottom: 0;
}

.cell-contents {
  padding-bottom: 1rem;
  border-bottom: 1px solid #ddd;
}

.rubik-400 {
  font-weight: 500;
}

p.px-3, span.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.paid-checkmark {
  background: #21eb47;
  padding: 0.75rem;
  border-radius: 100px
}

.has-text-green {
  color: #02b03e
}
</style>
